/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Learn_TitleInputs */

const en_gc_resources_learn_title = /** @type {(inputs: Gc_Resources_Learn_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A good place to learn GridCraft.`)
};

const zh_gc_resources_learn_title = /** @type {(inputs: Gc_Resources_Learn_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习 GridCraft，从这里开始。`)
};

/**
* | output |
* | --- |
* | "A good place to learn GridCraft." |
*
* @param {Gc_Resources_Learn_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_learn_title = /** @type {((inputs?: Gc_Resources_Learn_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Learn_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_learn_title(inputs)
	return zh_gc_resources_learn_title(inputs)
});
export { gc_resources_learn_title as "gc.resources.learn.title" }